<div
  class="chatbot-history-item list-group-item list-group-item-action d-flex align-items-start gap-2 border-0 rounded-3 px-2 py-2"
  :class="{ active: is_active }"
  role="button"
  @click="$emit('select', conversation.id)"
>
  <div class="flex-grow-1 overflow-hidden">
    <p class="text-white text-xs fw-semibold mb-0 text-truncate">
      {{ conversation_title }}
    </p>
    <p class="text-white-50 text-xs mb-0 text-truncate">
      {{ conversation_preview }}
    </p>
    <time
      v-if="conversation_timestamp"
      class="d-block mt-1 text-xs text-white-50"
      :datetime="conversation_timestamp_value"
      :title="conversation_timestamp"
    >
      {{ conversation_date_label }}
    </time>
  </div>

  <button
    v-if="can_delete"
    type="button"
    class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn chatbot-delete-btn flex-shrink-0"
    @click.stop="$emit('delete', conversation.id)"
    aria-label="Delete conversation"
    title="Delete conversation"
  >
    <i class="bi bi-trash3"></i>
  </button>
</div>
